(function () {
  'use strict';

  const openStateClass = 'is-visible';
  const closeDelay = 300;
  let lastTrigger = null;
  let lastImageTrigger = null;

  function usesSquareFeet(drawer) {
    return ['US', 'GB', 'CA'].includes((drawer.dataset.countryCode || '').toUpperCase());
  }

  function formatPrices(drawer) {
    const rate = Number(drawer.dataset.currencyRate || 1) || 1;
    const currency = drawer.dataset.currencyCode || 'USD';
    const squareFeet = usesSquareFeet(drawer);
    let formatter;

    try {
      formatter = new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency,
        minimumFractionDigits: squareFeet ? 2 : 0,
        maximumFractionDigits: squareFeet ? 2 : 0
      });
    } catch (_) {
      formatter = { format: (value) => '$' + Math.round(value) };
    }

    drawer.querySelectorAll('[data-material-guide-price]').forEach((node) => {
      const baseCents = Number(node.dataset.materialGuidePrice || 0);
      const convertedPrice = (baseCents / 100) * rate;
      node.textContent = formatter.format(squareFeet ? convertedPrice / 10.7639 : convertedPrice);
      node.dataset.materialGuideUnit = squareFeet ? ' / sq ft' : ' / m²';
    });
  }

  function closeZoom(drawer, restoreFocus) {
    const zoom = drawer?.querySelector('[data-material-guide-zoom]');
    if (!zoom || zoom.hidden) return false;
    const image = zoom.querySelector('[data-material-guide-zoom-image]');
    zoom.hidden = true;
    zoom.setAttribute('aria-hidden', 'true');
    image.removeAttribute('src');
    image.alt = '';
    const focusTarget = restoreFocus || lastImageTrigger;
    if (focusTarget) focusTarget.focus({ preventScroll: true });
    lastImageTrigger = null;
    return true;
  }

  function openZoom(drawer, trigger) {
    const source = trigger?.querySelector('img');
    const zoom = drawer?.querySelector('[data-material-guide-zoom]');
    if (!source || !zoom) return;
    const image = zoom.querySelector('[data-material-guide-zoom-image]');
    const caption = zoom.querySelector('[data-material-guide-zoom-caption]');
    lastImageTrigger = trigger;
    image.src = trigger.dataset.materialGuideImageSrc || source.currentSrc || source.src;
    image.alt = source.alt;
    caption.textContent = source.alt;
    zoom.hidden = false;
    zoom.setAttribute('aria-hidden', 'false');
    zoom.querySelector('[data-material-guide-zoom-close]')?.focus({ preventScroll: true });
  }

  function openDrawer(drawer, trigger) {
    if (!drawer || drawer.open) return;
    lastTrigger = trigger || null;
    formatPrices(drawer);
    closeZoom(drawer);
    const content = drawer.querySelector('.material-guide-drawer__content');
    drawer.showModal();
    if (content) content.scrollTo({ top: 0, behavior: 'auto' });
    requestAnimationFrame(() => {
      if (content) content.scrollTo({ top: 0, behavior: 'auto' });
      drawer.classList.add(openStateClass);
    });
    drawer.querySelector('[data-material-guide-close]')?.focus({ preventScroll: true });
  }

  function closeDrawer(drawer) {
    if (!drawer || !drawer.open) return;
    closeZoom(drawer);
    drawer.classList.remove(openStateClass);
    window.setTimeout(() => {
      if (drawer.open) drawer.close();
      lastTrigger?.focus({ preventScroll: true });
      lastTrigger = null;
    }, window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : closeDelay);
  }

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-material-guide-open]');
    if (opener) {
      event.preventDefault();
      const drawer = document.getElementById(opener.getAttribute('aria-controls'));
      openDrawer(drawer, opener);
      return;
    }

    const close = event.target.closest('[data-material-guide-close]');
    if (close) closeDrawer(close.closest('[data-material-guide-drawer]'));

    const imageTrigger = event.target.closest('[data-material-guide-image]');
    if (imageTrigger) {
      openZoom(imageTrigger.closest('[data-material-guide-drawer]'), imageTrigger);
      return;
    }

    const zoomClose = event.target.closest('[data-material-guide-zoom-close]');
    if (zoomClose) {
      closeZoom(zoomClose.closest('[data-material-guide-drawer]'));
    }
  });

  document.querySelectorAll('[data-material-guide-drawer]').forEach((drawer) => {
    formatPrices(drawer);
    drawer.addEventListener('cancel', (event) => {
      event.preventDefault();
      const zoom = drawer.querySelector('[data-material-guide-zoom]');
      if (zoom && !zoom.hidden) {
        closeZoom(drawer);
        return;
      }
      closeDrawer(drawer);
    });
    drawer.addEventListener('click', (event) => {
      const zoom = drawer.querySelector('[data-material-guide-zoom]');
      if (event.target === zoom) {
        closeZoom(drawer);
        return;
      }
      if (event.target === drawer) closeDrawer(drawer);
    });
  });
})();
